import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { concatMap, take, tap } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericError } from '@auth0/auth0-spa-js';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import {
  ErrorModalComponent,
  ErrorModalData,
} from '@cp/ui/modal/modals/error-modal/error-modal.component';
import { ModalService } from '@cp/ui/modal/modal.service';
import { getAuth0OrgErrorUrls } from '../../../environments/environment.helper';

@Component({
  selector: 'cp-error',
  template: '<ng-container *ngIf="auth0Error$ | async"></ng-container>',
  styles: [''],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  public auth0Error$ = this._authService.error$.pipe(
    take(1),
    concatMap((error) => {
      const errorModalData: ErrorModalData = {
        title: 'Authentication Error',
        errors: [],
      };

      if (error instanceof GenericError) {
        let errMessage = error.error_description;
        if (
          errMessage.indexOf(
            `is not part of the ${this._environment.auth0.organization} organization`,
          ) !== -1
        ) {
          const { tns, sng } = getAuth0OrgErrorUrls(window.location.origin);
          errorModalData.errors.push(
            "Looks like you're logging into the wrong portal.",
          );
          errMessage = `If you’re already a worker and trying to login to Thornbury please go to ${tns}, for The Guild go to ${sng}.`;
        }
        errorModalData.errors.push(errMessage);
      }

      if (errorModalData.errors.length === 0) {
        errorModalData.errors.push('Something went wrong.');
        errorModalData.errors.push('Please login again, and try again.');
      }

      const modalRef: MatDialogRef<ErrorModalComponent, void> =
        this._modalService.openModalFromComponent<
          ErrorModalComponent,
          ErrorModalData
        >(ErrorModalComponent, errorModalData);

      return modalRef.afterClosed().pipe(
        tap(() => {
          this._authService.loginWithRedirect({
            appState: { target: '/logged-in' },
          });
        }),
      );
    }),
  );

  constructor(
    private _authService: AuthService,
    private _modalService: ModalService,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}
}
